import styled from 'styled-components'
import { black, textMuted } from '@/theme/colors'
import { motion } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export const Row = styled.div<{ $disabled?: boolean }>`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 24px;
	opacity: ${props => (props.$disabled ? 0.5 : 1)};
	transition: opacity ${motion.base};
`

export const RowText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const RowTitle = styled.span`
	font-size: ${fontSizes.base};
	font-weight: 700;
	color: ${black};
`

export const RowDescription = styled.span`
	font-size: ${fontSizes.caption};
	color: ${textMuted};
	line-height: ${leading.body};
`

export const ToggleWrapper = styled.div`
	position: relative;
	flex-shrink: 0;
	margin-top: 2px;
`
